import axios from '../axios';

export class AuthHelper {
    static async logoutUser() {
        localStorage.removeItem('accessToken');
        delete axios.defaults.headers.common.Authorization;
    }

    static getFirebaseAccessToken() {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith('firebase:authUser')) {
                try {
                    const authData = JSON.parse(localStorage.getItem(key));
                    return authData?.stsTokenManager?.accessToken || null;
                } catch (e) {
                    console.error('Error parsing Firebase auth data:', e);
                    return null;
                }
            }
        }
        return null;
    }

    static getFirebaseRefreshToken() {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith('firebase:authUser')) {
                try {
                    const authData = JSON.parse(localStorage.getItem(key));
                    return authData?.stsTokenManager?.refreshToken || null;
                } catch (e) {
                    console.error('Error parsing Firebase auth data:', e);
                    return null;
                }
            }
        }
        return null;
    }

    static setBearerToken(accessToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    }
}
